import * as yup from "yup";

const educationBackgroundSchema = yup.object({
    level: yup.string().trim().required("Level is required."),

    schoolName: yup.string().trim().required("School name is required.")
});

export default educationBackgroundSchema;
